import { HttpClient } from "@angular/common/http";
import { BaseApiClient } from "./base-api-client";

export class TokenClient extends BaseApiClient {
    private token: string | null = null;

    constructor(
        http: HttpClient,
    ) {
        super(http);
    }

    setToken(token: string | null) {
        this.token = token;
    }

    override getAdditionalHeaders(): { [key: string]: string; } {
        if (this.token === null) {
            return {}
        }

        return {
            'Authorization': `Bearer ${this.token}`,
        }
    }
}
